var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwaziland(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m486.598 367.304c16.274-33.655 25.402-71.414 25.402-111.304s-9.128-77.649-25.402-111.304l-230.598-11.131-230.598 11.13c-16.274 33.656-25.402 71.415-25.402 111.305s9.128 77.649 25.402 111.304l230.598 11.131z",
    fill: "#ffda44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-101.494 0-189.19 59.065-230.598 144.696h461.195c-41.407-85.631-129.104-144.696-230.597-144.696z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m256 512c-101.494 0-189.19-59.065-230.598-144.696h461.195c-41.407 85.631-129.104 144.696-230.597 144.696z",
    fill: "#0052b4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m499.911 178.087h-487.822c-7.842 24.569-12.089 50.744-12.089 77.913s4.247 53.344 12.089 77.913h487.821c7.843-24.569 12.09-50.744 12.09-77.913s-4.247-53.344-12.089-77.913z",
    fill: "#a2001d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffda44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m89.043 244.87h333.913v22.261h-333.913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.565 200.348h244.87v22.261h-244.87z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m380.025 256s-57.243 66.783-124.025 66.783-66.783-66.783-66.783-66.783 0-66.783 66.783-66.783 124.025 66.783 124.025 66.783z",
    fill: "#f0f0f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m256 322.783c-66.783 0-124.025-66.783-124.025-66.783s57.242-66.783 124.025-66.783"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m211.478 233.739h22.261v44.522h-22.261z",
    fill: "#f0f0f0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m278.261 233.739h22.261v44.522h-22.261z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0052b4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.043,
    cy: 256,
    r: 22.261
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.957,
    cy: 256,
    r: 22.261
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwaziland);
export default __webpack_public_path__ + "static/media/swaziland.6a9a35996415f624d46a415c7ec3f575.svg";
export { ForwardRef as ReactComponent };